<!--
 * @Description: 取消订单
 * @Author: ganjia
 * @Date: 2019-10-14 10:19:21
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="cancelOrder">
    <el-dialog :title="$lang('取消订单')" :visible.sync="dialogTableVisible" :close-on-click-modal="false" :modal-append-to-body='true' width="400px">
      <div  class="dialog-center1">
        <p class="dialog-p1">{{$lang('请选择取消订单原因')}}</p>
        <div class="radio">
          <el-radio-group v-model="radio2">
            <el-radio style="margin-bottom:16px;width:100%" :label="1" :title="$lang('下单等太久，快递员未来取件')">{{$lang('下单等太久，快递员未来取件')}}</el-radio>
            <el-radio style="margin-bottom:16px;width:100%" :label="2" :title="$lang('计划有变暂时不需要寄件了')">{{$lang('计划有变暂时不需要寄件了')}}</el-radio>
            <el-radio style="margin-bottom:16px;width:100%" :label="3" :title="$lang('赶时间更改为其他寄件方式')">{{$lang('赶时间更改为其他寄件方式')}}</el-radio>
            <el-radio style="margin-bottom:16px;width:100%" :label="4" :title="$lang('订单信息填写有误，需要修改')">{{$lang('订单信息填写有误，需要修改')}}</el-radio>
            <el-radio style="margin-bottom:16px;width:100%" :label="5" :title="$lang('其它')">{{$lang('其它')}}</el-radio>
          </el-radio-group>
        </div>
        <div class="textarea">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6}"
            :placeholder="$lang('请填写订单取消原因')"
            :maxlength="40"
            v-model="textarea">
          </el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="h40" @click="comfirmCancel" :loading="cancelOrderLoading">{{$lang('确定取消')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { orderCancel } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants/index'

export default {
  name: 'CancelOrder',
  data() {
    return {
      dialogTableVisible: false,
      radio2: 1,
      textarea: '',
      cancelOrderLoading: false,
    }
  },
  props: {
    selectId: {
      type: String,
      default: '',
    },
  },
  methods: {
    async comfirmCancel() {
      if (!this.selectId) return
      this.cancelOrderLoading = true
      const params = { orderIds: this.selectId.split(','), reason: this.textarea, from: 8 }
      const { code, msg } = await orderCancel(params)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('取消成功'))
      } else {
        this.$message.error(msg)
      }
      this.cancelOrderLoading = false
      this.$emit('cancelSuccess')
      this.dialogHide()
    },
    dialogHide() {
      this.radio2 = 1
      this.textarea = ''
      this.dialogTableVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
  .dialog-p1{
    padding: 24px;
    height:24px;
    font-size:18px;
    font-family:PingFangSC-Regular,PingFangSC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:24px;
    margin: 0;
  }
  .radio{
    padding: 0 24px;
    height: 160px;

  }
  .textarea{
    width: 304px;
    margin: 0 auto;
  }
  .el-dialog__footer {
      padding: 8px 24px 16px;
      text-align: right;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
</style>
<style lang="scss">
.cancelOrder{
    .el-radio{
    margin-bottom: 16px;
    width: 300px !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>

